export enum FiDialogCloseReason {
    YesButton = 0, // ok , confirm, I understood etc
    NoButton = 1, // cancel, close, etc
    DontShowAgain = 2,
}
